import React from 'react';
import ReactDOM from 'react-dom';
import {OSAnalyticsPage} from '../widget/osAnalyticsPage.jsx'
import {OSLandingPage} from '../widget/osExtDashboard.jsx'
import {OSLandingPagePublic} from '../widget/osWidgetPublic.jsx'
import {ExternalOSSMenu, ChatbotExt} from '../common/components.jsx'

window["React"] = React;
window["ReactDOM"] = ReactDOM;
window["GET"] = GET;
window["I18N"] = I18N;
window["getQueryParams"] = getQueryParams;
window["ExternalOSSMenu"] = ExternalOSSMenu;
window["ChatbotExt"] = ChatbotExt;
window["OSLandingPage"] = OSLandingPage;
window["OSAnalyticsPage"] = OSAnalyticsPage;
window["OSLandingPagePublic"] = OSLandingPagePublic;
window["$"]= $;